import { useEffect, useRef } from 'react';

export default function FastProductionSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out bg-background-200 rounded-lg overflow-hidden min-h-[300px] border border-background-300/60">
            <img
              src="https://readdy.ai/api/search-image?query=Craftsman%20working%20in%20modern%20workshop%20cutting%20acrylic%20house%20number%20plates%20with%20laser%20machine%2C%20warm%20industrial%20lighting%2C%20tools%20and%20materials%20on%20workbench%2C%20professional%20workshop%20photography%20with%20dramatic%20shadows%2C%20craftsman%20hands%20working%20on%20premium%20signage%20production&width=800&height=600&seq=fast-production-2026&orientation=landscape"
              alt="Brza izrada u radionici"
              className="w-full h-full min-h-[300px] object-cover rounded-lg"
            />
          </div>

          <div>
            <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              BRZA IZRADA
            </h2>
            <p className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-100 ease-out text-base text-foreground-700 leading-relaxed">
              Kućni brojevi i pločice za vrata, sa prezimenom ili za poštansko sanduče, personalizovani izrađuju se svakodnevno. Pre konačne potvrde porudžbine, dostavljamo vam vizuelni prikaz odabranog proizvoda. Proizvodi se šalju već narednog radnog dana.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}